import { Box, Text, Stack, CircularProgress } from '@/theme/index';

export const UpgradePremiumDataModal = () => {
  return (
    <Stack
      direction="column"
      display="flex"
      justifyContent="center"
      alignItems="center"
      p={2}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'white',
        zIndex: 9999,
      }}
    >
      <Box sx={{ position: 'relative' }} data-testid="circular-progress-item">
        <CircularProgress
          variant="determinate"
          size={120}
          sx={{
            color: (theme) => theme.palette.secondary.light,
          }}
          thickness={1}
          value={100}
        />
        <CircularProgress
          variant="indeterminate"
          disableShrink
          size={120}
          sx={{
            color: (theme) => theme.palette.primary.main,
            animationDuration: '1500ms',
            position: 'absolute',
            left: 0,
          }}
          thickness={1}
        />
      </Box>
      <Text
        variant="h1"
        sx={{ mb: 1, mt: 4 }}
        color="primary"
        data-testid="premium-data-modal-title"
      >
        Searching for FREE Premium Data
      </Text>
      <Text
        variant="body1"
        sx={{ mb: 2 }}
        data-testid="premium-data-modal-body"
      >
        Please wait while we search for premium data
      </Text>
    </Stack>
  );
};
